
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import TemplatesListView from "./templates-list.html";
import TemplatesEditView from "./templates-edit.html";

angular.module("templates", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('templates', {
                url: "/templates",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('templates.list', {
                url: "/list",
                controller: "TemplatesListCtrl",
                template: TemplatesListView,
                cache: false,
                requiredPermission: ["TEMPLATES_READ"]
            })            
            .state('templates.edit', {
                url: "/edit/:id",
                controller: "TemplatesEditCtrl",
                template: TemplatesEditView,
                cache: false,
                requiredPermission: ["TEMPLATES_READ"]
            })
    }])
;